import script from "./VitaPrintTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaPrintTable.vue?vue&type=script&setup=true&lang=ts"

import "./VitaPrintTable.vue?vue&type=style&index=0&id=0d57647b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d57647b"]])

export default __exports__